export type StartDeck = {
  intern: number;
  idle: number;
  hedge: number;
  allowBringIn: boolean;
};

function clampCount(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(20, Math.floor(value)));
}

export function defaultStartDeck(): StartDeck {
  return { intern: 7, idle: 3, hedge: 0, allowBringIn: false };
}

export function normalizeStartDeck(raw: Partial<StartDeck> | undefined): StartDeck {
  const next = {
    intern: clampCount(raw?.intern ?? 7),
    idle: clampCount(raw?.idle ?? 3),
    hedge: clampCount(raw?.hedge ?? 0),
    allowBringIn: Boolean(raw?.allowBringIn),
  };
  if (next.intern + next.idle + next.hedge === 0) next.intern = 1;
  return next;
}

export function startDeckCardIds(deck: StartDeck): string[] {
  return [
    ...Array.from({ length: deck.intern }, () => "intern"),
    ...Array.from({ length: deck.idle }, () => "idle"),
    ...Array.from({ length: deck.hedge }, () => "hedge"),
  ];
}
